import React from 'react'
import './styles.scss'
import namImage from 'assets/portfolio/image/nam.jpg'
import tuanImage from 'assets/portfolio/image/tuan.jpg'
import vuImage from 'assets/portfolio/image/vu.jpg'
import downloadIcon from 'assets/portfolio/image/download.svg'
import { downloadCVs } from 'utils/downloadCv'

const About = () => {
  return (
    <div className="about">
      <div className="about-left">
        <h4>Hi There, We Are Software Developer</h4>
        <span>
          We are a special group, consisting of 3 talented interns in the field of frontend
          development. Join us on our journey of learning and creativity in the world of user
          interface development!
        </span>
        <div className="button">
          <button className="button-primary">Hire Us</button>
          <button className="button-secondary" onClick={downloadCVs}>
            <img src={downloadIcon} alt="downloadIcon" className="download" />
            Download CV
          </button>
        </div>
      </div>

      <div className="about-right">
        <div className="circular">
          <img src={vuImage} alt="Developer 3" />
        </div>
        <div className="wrap-image">
          <div className="circular">
            <img src={namImage} alt="Developer 1" />
          </div>
          <div className="circular">
            <img src={tuanImage} alt="Developer 2" />
          </div>
        </div>
      </div>
    </div>
  )
}

export default About
